import { render, staticRenderFns } from "./player-ore-graph.vue?vue&type=template&id=512fd738&scoped=true&"
import script from "./player-ore-graph.vue?vue&type=script&lang=js&"
export * from "./player-ore-graph.vue?vue&type=script&lang=js&"
import style0 from "./player-ore-graph.vue?vue&type=style&index=0&id=512fd738&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512fd738",
  null
  
)

export default component.exports